module.exports = __webpack_public_path__ + "static/media/icon-gym-02.07e10137.svg";